import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithAuth from "./baseQueryWithAuth";

const openaiApi = createApi({
    reducerPath: "openai",
    baseQuery: baseQueryWithAuth,
    endpoints: (build) => ({
        status: build.query({
            query: () => "/",
        }),
        createCompletion: build.mutation({
            query: (data) => ({
                url: "/create-completion",
                method: "POST",
                body: data,
            }),
        }),
    }),
});

export const {
    useCreateCompletionMutation,
} = openaiApi;

export default openaiApi;
